import { FaMapMarkerAlt } from "react-icons/fa";
import { useLocation } from "react-router";
import GoogleMapReact from "google-map-react";
import { GOOGLE_MAPS_APIKEY } from "../../store/Apis";
import styles from "./Map.module.css";
import { useEffect, useState } from "react";
const AnyReactComponent = ({ text }) => (
  <div className={styles.marker}>
    <FaMapMarkerAlt style={{ color: "var(--secondary-color)", fontSize: 28 }} />
    {/* <div className={styles.txt}>3131 94th St, East Elmhurst, NY, 11369</div> */}
  </div>
);
const Map = () => {
  const { state } = useLocation();

  let lat = state?.latitude;
  let lng = state?.longitude;
  
  console.log("latlng", state);
  const defaultProps = {
    center: {
      lat: lat ? parseFloat(lat) : 0,
      lng: lng ? parseFloat(lng) : 0,
    },
    zoom: 5,
  };
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {/* {state?.latitude || state?.longitude ? ( */}
      <GoogleMapReact
        bootstrapURLKeys={{ key: GOOGLE_MAPS_APIKEY }}
        center={defaultProps?.center}
        defaultZoom={defaultProps?.zoom}
      >
        <AnyReactComponent
          lat={state?.latitude}
          lng={state?.longitude}
          text="My Marker"
        />
      </GoogleMapReact>
      {/* ) : null} */}
    </div>
  );
};
export default Map;
